// extracted by mini-css-extract-plugin
export default {"content":"_1Pr-Sk","contentWrapper":"FKC8iI","container":"_2-YsT_"};